module.exports = __webpack_public_path__ + "assets/ico-parking-logo.e1b8733c.svg";